import { render, staticRenderFns } from "./TileDataPdok.vue?vue&type=template&id=68029baa"
import script from "./TileDataPdok.vue?vue&type=script&lang=js"
export * from "./TileDataPdok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports